<template>

	<div class="">
		<div class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<img :src="welcome" alt="Welcome to MyMeds" :class="width < 992 ? 'w-75' : 'w-40'"  />
			<h1 class="text-center mt-3">Welcome to My Meds</h1>
			<p class="text-center text-muted mt-1">Let's help you personalize your account with a few simple steps.</p>

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('skip')">not now</button>
				<button class="btn btn-dark rounded-pill py-7 " :class="width < 992 ? 'w-75' : 'w-50'" @click="moveButtonAction('username')">Continue</button>
			</div>
		</div>

	</div>
</template>

<script setup>

import welcome from '@/assets/welcome.svg';

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});

const emits = defineEmits(['navigationButtonClicked']);
const moveButtonAction = (name) => {
	emits('navigationButtonClicked', name);
}

</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>